export default __webpack_public_path__ + "static/media/endpomo.c35664ce.wav";